<template lang='pug'>
v-lazy(ref="topToScroll")
	.card-solution(
		v-bind="$attrs"
		:class="{'tw-opacity-50': disabled, 'card-solution-expanded': expanded}"
	)
		.tw-card.tw-cursor-pointer.tw-p-0.tw-border-0.tw-overflow-hidden.tw-rounded-t-card.tw-rounded-b-none(
			class='last:tw-rounded-b-card'
			@click="getTravelPrices()" 
			:class="{'tw-cursor-not-allowed': disabled}"
		)
			.tw-bg-white.tw-px-10.tw-py-6(class="emd:tw-p-5")
				div.tw-flex.tw-items-center.tw-gap-2(v-if='trainBreadcrumbs')
					template(v-for="(trainBreadcrumb, ii) in trainBreadcrumbs" :key="ii")
						img.train-icon(v-if="trainBreadcrumb.icon" :src="trainBreadcrumb.icon" class="emd:tw-w-25")
						strong(class="tw-text-[12px]" v-if="'V6' == trainBreadcrumb.name") {{ trainBreadcrumb.denomination }}
						strong(class="tw-text-[12px]" v-if="'Urb' != trainBreadcrumb.name") {{ trainBreadcrumb.name }}
						span(v-if="ii < (trainBreadcrumbs.length - 1)") /
				.tw-flex.tw-items-center.tw-mt-2(class="emd:tw-flex-col")
					div.tw-flex.tw-items-center(:class="isMobile || 'carnet' == source ? 'tw-w-full' : 'tw-basis-7/12'")
						div(class="tw-basis-1/6")
							span.tw-text-primary-dark.tw-text-semibold(class="tw-text-[24px] emd:tw-text-2xl") {{ descriptions && descriptions.departureLocaleTime }}
							br
							span {{ travelSolution.start.stationName }}
						div.tw-flex-1.tw-flex
							div.tw-flex-1.tw-flex.tw-items-center.tw-justify-center
								hr(class="tw-w-3/4 tw-h-0 tw-border-dashed tw-border-t-[0.063rem] tw-border-[#e3e6ed] tw-box-content")
							span.tw-font-semibold {{ travelSolution.duration }}
							div.tw-flex-1.tw-flex.tw-items-center.tw-justify-center
								hr(class="tw-w-3/4 tw-h-0 tw-border-dashed tw-border-t-[0.063rem] tw-border-[#e3e6ed] tw-box-content")
						div(class="tw-basis-1/6")
							span(class="tw-text-[24px] tw-text-primary-dark tw-text-semibold") {{ descriptions && descriptions.arrivalLocaleTime }}
							br
							span {{ travelSolution.end.stationName }}
					.tw-flex.tw-items-center.tw-justify-between(class="md:tw-basis-5/12 emd:tw-w-full")
						div(class="md:tw-flex-1 md:tw-text-center")
							v-btn(
								append-icon='mdi-information-outline'
								elevation="0"
								variant="text"
								color="primary-darken-1"
								@click.stop.prevent="getTravelDetails()"
								x-small
							)
								span(v-if="trainBreadcrumbs.length > 1")
									| {{(trainBreadcrumbs.length - 1)}} Cambi{{(trainBreadcrumbs.length - 1) == 1 ? 'o' : ''}}
								span(v-else) {{$t('sale.travel_solution.details', 'Dettagli')}}
						div(class="md:tw-mt-[-0.5rem] tw-self-start md:tw-basis-5/12 emd:tw-mt-3")
							span.tw-float-right.prezzo(v-if="selectionMode == 'select'")
								v-btn(color="primary-darken-1") {{$t('sale.travel_solution.select', 'SELEZIONA')}}
							span.tw-float-right.price-start-from.tw-gap-2.tw-flex.tw-flex-col.tw-justify-end(v-else-if="selectionMode == 'best_price'" class="md:tw-text-right")
								small.tw-mr-4(class="tw-text-[#8d8d8d]") {{$t('sale.travel_solution.starting_from', 'A partire da')}}
								div.tw-flex.tw-items-center.tw-text-primary-dark.tw-justify-end.tw-font-bold
									span {{formattedPrice}}
									v-icon(icon="mdi-menu-down" small)
								//span {{bookingAppSettingsStore.currency[travelSolution.bestPrice.currency]}} {{travelSolution.bestPrice.amount}}
							span.tw-float-right.prezzo(v-else-if="selectionMode == 'select_offer'")
								v-btn(color="primary-darken-1" variant="text") {{$t('sale.travel_solution.select', 'SELEZIONA')}}
							div.tw-flex.tw-flex-col.tw-items-center.tw-float-right(v-else class="tw-text-[#8d8d8d]")
								div.tw-inline.tw-relative
									v-icon(icon="mdi-block-helper" size="x-large" color="#8d8d8daa")
									v-icon.tw-absolute(class="tw-top-[60%] tw-left-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2" icon="mdi-cart" size="small" color="#8d8d8d")
								span.tw-font-semibold(class="tw-text-[12px]") {{$t('sale.travel_solution.not_purchasable', 'Non Acquistabile')}}

			template(v-if="travelSolution.messages")
				div.tw-px-10.tw-py-2.tw-flex.tw-items-center.tw-gap-2(
					v-for="(message, i) in travelSolution.messages" :key='i'
					:class="{'tw-bg-[#dfdfdf]': message.value != 21, 'tw-bg-[#fef7eb]': message.value == 21}"
				)
					v-icon(icon="mdi-human-male-female-child" v-if="message.value == 21")
					span(class="tw-text-[#707070]") {{message.description}}
				div.tw-px-10.tw-py-2.tw-flex.tw-items-center.tw-gap-2(v-if='isSuccessiveDate' class="tw-bg-[#dfdfdf]")
					v-icon(icon="mdi-alert-circle")
					span {{$t('sale.travel_solution.day_attention', 'Attenzione giorno di partenza diverso dal giorno di ricerca')}}
		v-expand-transition
			div.solution-expanded-content.tw-px-10.tw-py-2(v-if="expanded" class="tw-bg-[#fafafa] emd:tw-px-4")
				travel-solution-detail(v-if="detailType == 'detail'" :solution="travelSolution" :loading='detailLoading')
				template(v-else-if="detailType == 'price'")
					carnet-solution-services(
						v-if="'carnet' == source"
						:solution-id="travelSolution.xmlId"
						:offered-services="travelSolution.offeredServices"
						:catalog-services="catalogServices"
						@selectedService='expandedSolutionIndex = i'
					)
					travel-solution-price-grids(v-if="'carnet' != source && !travelSolutionSelectionState.useCustomizedOffers && !isMobile")
					keep-alive: customize-offer(v-if="'carnet' != source && (travelSolutionSelectionState.useCustomizedOffers || isMobile)" :travelSolution='travelSolution' @update:travel-solution="emit('update:travel-solution', $event)")
		v-expand-transition
			div.tw-card.tw-bg-white.tw-flex.tw-justify-between.tw-gap-8.tw-items-center.tw-px-10.tw-rounded-t-none(
				v-if='selected && expanded'
				class='last:tw-rounded-b-card emd:tw-gap-2 emd:tw-px-5 emd:tw-justify-between'
			)
				div.tw-flex-1(v-if="!isMobile")
					v-btn(
						variant='outlined'
						color="primary-darken-1"
						v-if="('travelSolution' == source || 'travelChange' == source) && !travelSolutionSelectionState.useCustomizedOffers"
						@click='travelSolutionSelectionState.useCustomizedOffers = true;detailType = "price";emit("expand");'
					) {{$t('sale.travel_solution.other_offers', 'Vedi altre offerte')}}
					v-btn(
						variant='outlined'
						v-if="('travelSolution' == source || 'travelChange' == source) && travelSolutionSelectionState.useCustomizedOffers && !travelSolution.require_offer_map"
						@click='travelSolutionSelectionState.useCustomizedOffers = false'
					) {{$t('common.back', 'Indietro')}}
				div.tw-flex.tw-gap-6.tw-items-center.tw-justify-between(
					v-if="'not_saleable' != selectionMode"
					:class="!showSwitch ? 'emd:tw-justify-center' : ''"
					)
					v-switch.tw-shrink(
						v-if="showSwitch"
						color='primary-darken-1'
						:model-value="requestSeatSelection"
						@update:model-value="updateRequestSeatSelection($event)"
						:disabled="!canRequestSeatSelection || continueBookingBtnProps.disabled || stepper.nextLoading"
						:label="$t('form_labels.travel_solution.seats_choose', 'Scegli posti')"
						hide-details
					)
				div(v-if="'not_saleable' != selectionMode")
					v-btn.mr-4(
						color="primary-darken-1"
						v-bind="continueBookingBtnProps"
						class="text-none text-white"
					)
						span {{$t('common.continue', 'Continua')}}
						v-icon(icon="mdi-chevron-right")
</template>

<script setup>
import TravelSolutionDetail from './travelSolutionDetail.vue';
import { useBookingStore } from '@/stores/booking';
import CustomizeOffer from './customize-offer/customize-solution.vue';
import TravelSolutionPriceGrids from './price-grid/travel-solution-price-grids.vue'
import CarnetSolutionServices from "@/sale/components/tab2_travel_solutions/carnet/carnetSolutionServices.vue";
import {inject, ref, computed, triggerRef, provide, watch, onMounted, onActivated} from 'vue';
import {printCurrencyValue} from "../../../common-scripts/utilities";
import {usePostSaleStore} from "@/stores/post-sale";
import {useDialogManagerStore} from "@/stores/dialog-manager";
import { getTrainBreadcrumbs } from '@/common-scripts/train-helper';
import {get as _get} from 'lodash-es';
import {useI18n} from "vue-i18n";
import {useBookingStepperStore} from "@/stores/booking-stepper";
import { useDisplay } from 'vuetify'


const i18n = useI18n();
const bookingStore = useBookingStore();
const $axios = inject('axios');
const searchFormData = inject('searchFormData', null);
const detailLoading = ref(false);
const detailType = ref('');
const postSale = usePostSaleStore();
const dialogManager = useDialogManagerStore();
const {
	selectedOffersData,
	setSelectedSolution, 
	setSelectedTrainGridOffer,
	evaluateAndGoNext,
	canRequestSeatSelection,
	travelSolutionView: selectedTravelSolution,
	state: travelSolutionSelectionState
} = inject('travelSolutionSelection');

const showSwitch = computed(() => {
	// if ( postSale.selectedEdit && ('booking_change_before_departure' == postSale.selectedEdit || "travel_change_before_departure" == postSale.selectedEdit)) return false;
	if ( 'carnet' == props.source) return false;

	return true;
});
const props = defineProps({
	travSol: {
		type: Object,
		required: true
	},
	scrollHere: Boolean,
	solutionIndex: Number,
	expanded: Boolean,
	autoOpenCustomizedOffers: {
		type: Boolean,
		default: false
	},
	source: {
		type: String,
		default: 'travelSolution'
	},
	catalogServices: {
		type: Object,
		default: {}
	}
});

const travelSolution = computed(() => {
	return props.travSol.returnTravelSolution || props.travSol;
});
const descriptions = computed(() => {
	const result = {};
	if(travelSolution.value.departure) result.departureLocaleTime = new Date(travelSolution.value.departure).toLocaleTimeString(undefined, {hour:'2-digit', minute: '2-digit', hour12: false});
	if(travelSolution.value.arrival) result.arrivalLocaleTime = new Date(travelSolution.value.arrival).toLocaleTimeString(undefined, {hour:'2-digit', minute: '2-digit', hour12: false});
	return result;
});
const selected = computed(() => selectedTravelSolution.value && selectedTravelSolution.value.solutionId == travelSolution.value.solutionId);
const emit = defineEmits(['expand', 'unexpand', 'addToCart', 'showMovementDetails', 'update:travel-solution']);
const trainBreadcrumbs = computed(() => getTrainBreadcrumbs(travelSolution.value.trains));
const isSuccessiveDate = computed(() => {
	const searchDate = _get(searchFormData, 'date', _get(bookingStore, 'searchFilters.startDate')); 
	if(!searchDate || !travelSolution.value.departure) return false;
	const deparuteDate = new Date(travelSolution.value.departure);
	return searchDate.getDate() < deparuteDate.getDate() || searchDate.getMonth() < deparuteDate.getMonth();
});
const selectionMode = computed(() => {
	if(!travelSolution.value.saleable) return 'not_saleable';
	if('bookingChange' == props.source) return 'select';
	if(travelSolution.value.bestPrice) return 'best_price';
	if(travelSolution.value.require_offer_map) return 'select_offer'; // solution cant use grid
	return 'not_saleable';
});
const disabled = computed(() => !['carnet', 'bookingChange'].includes(props.source) && selectionMode.value == 'not_saleable');
const disableNext = ref(false);
const stepper = useBookingStepperStore();
const topToScroll = ref();
const requestSeatSelection = computed(() => {
	return bookingStore.requestSeatSelection;
});
const isMobile = inject('isMobile');
const continueBookingBtnProps = computed( () => {
	const btnProps = {
		loading: bookingStore.carnet.loading || stepper.nextLoading,
		disabled: disableNext.value,
	}

	if(!['carnet', 'bookingChange', 'travelChange'].includes(props.source)){
		btnProps.disabled = !selectedTravelSolution.value;
	}

	if(!btnProps.disabled && props.source != 'carnet'){
		// TODO: check if all trains have prices
		// use disableContinueButton ? reworn in a function or merge here the method
	}

	if(!selectedTravelSolution.value || !selectedTravelSolution.value.saleable){
		btnProps.disabled = true;
	}else{
		if(travelSolutionSelectionState.useCustomizedOffers){
			// todo: check that all trains have offers for avery travellers in offers_map
		}else{
			if(!selectedTravelSolution.value.bestPrice) btnProps.disabled = true;
		}
	}

	if(props.source == 'carnet'){
		btnProps.onClick = () => emit('addToCart');
	}else if(props.source == 'bookingChange'){
		btnProps.onClick = () => emit('showMovementDetails');
	}else if(props.source == 'travelChange'){
		btnProps.onClick = () => postSale_selectForTravelChange();
	}else{
		btnProps.onClick = () => evaluateAndGoNext(props.travSol);
	}
	return btnProps;
});
const formattedPrice = computed(() => {
	return printCurrencyValue(travelSolution.value.bestPrice.amount, travelSolution.value.bestPrice.currency);
});


function updateRequestSeatSelection(event) {
	bookingStore.setRequestSeatSelection(event);
}
function toggleSelection(newDetailType){
	if(props.expanded && newDetailType == detailType.value){
		detailType.value = '';
		emit('unexpand');
	}else{
		detailType.value = newDetailType;
		if(newDetailType == 'price' && props.autoOpenCustomizedOffers && !travelSolutionSelectionState.useCustomizedOffers && travelSolution.value.offers_map){
			travelSolutionSelectionState.useCustomizedOffers = true;
		}

		if(!props.expanded) emit('expand');
	}
}
function getTravelDetails(){
	toggleSelection('detail');

	if (!travelSolution.value.trainsStops || travelSolution.value.trainsStops.length <= 0) {
		if (travelSolution.value.subSegments) {
			console.error('Da implementare !');
			// STESSA COSA DEL SOLUTION_NODE, SOLO SI CICLA IL SUBSEGMENT E SI PASSA OGNI SINGOLO ELEMENTO COME FOSSE UN SOLUTION_NODE
			return;
		}
		detailLoading.value = true;

		const trains = getTrainBreadcrumbs(travelSolution.value.trains);

		function findSolutionNode(id, solutionNodes){
			for (const solutionNode of solutionNodes) {
				if(solutionNode.idXml == id) return solutionNode;
				if(solutionNode.subSegments){
					const found = findSolutionNode(id, solutionNode.subSegments);
					if(found) return found;
				}
			}
			return null;
		}
		travelSolution.value.trainsStops = [];
		Promise.all(trains.map((train, n) => {
			const solutionNode = findSolutionNode(train.id, travelSolution.value.original.solutionNodes);
			if(!solutionNode){
				console.warn('solution node not found', train, travelSolution.value.original.solutionNodes);
				return;
			}

			return $axios.post("trenitalia/travel-stops", {
				solution_node: solutionNode
			})
			.then((response) => {
				travelSolution.value.trainsStops[n] = response.data;
			})
			.catch(e => {
				console.error('errore: ', e);
			});
		}))
		.then(() => {
			detailLoading.value = false;
		}).catch(e => {
			detailLoading.value = false;
			console.error('promise fail', e);
		});
	}
}
function getTravelPrices () {
	if(disabled.value) return;
	bookingStore.setRequestSeatSelection(false);

	setSelectedSolution((!props.expanded ? travelSolution.value : false), ('carnet' == props.source));
	// setSelectedSolution((!props.expanded ? props.travSol : false), ('carnet' == props.source));
	if(selectionMode.value == 'select_offer'){
		travelSolutionSelectionState.useCustomizedOffers = true;
	}

	// TODO: IMPOSTARE LE OFFERTE ED I SERVIZI GIA' SELEZIONATI
	if(['bookingChange'].includes(props.source)) {
		// 	bookingStore.setTravelSolutionCustomizable(props.travSol, travelSolution.servicesMap);
		//
		// 	// if () {
		// 	// 	disableNext.value = true;
		// 	// 	return;
		// 	// }
		// } else {
		emit('showMovementDetails');
		return;
	}

	toggleSelection('price');
}
function updatePriceGridSelection(priceKeys, trainId) {
	if(!selected.value) return;
	setSelectedTrainGridOffer(trainId, priceKeys.offerId, priceKeys.catalogServiceId);
}
function postSale_selectForTravelChange() {
	(async () => {
		await postSale.evaluateTravel({
			newTravelSolutionSelected: selectedTravelSolution.value.original,
			selectedOfferedServices: selectedOffersData.value,
			operationType: props.source,
			withSeatsSelection:bookingStore.requestSeatSelection
		});
		if (!postSale.isValidEvaluate) return ;

		if (bookingStore.requestSeatSelection) {
			// if (typeof bookingStore.evaluatedSolution !== 'object' || bookingStore.evaluatedSolution == null) bookingStore.setEvaluatedSolution();
			// bookingStore.setTrainSeatMaps(postSale.getNewSolutions.trainSeatMaps);
			postSale.newTravel.isSelected = true;
			stepper.goNext();
		} else {
			if (postSale.isForwardReturnFlow && !stepper.isAfterForwardTripSteps) {
				postSale.setReturnSearchCriteriaAndGoNext();

				return;
			}

			const r = await postSale.showDialogOfMovementDetails();
			if ('movementAccepted' == r.result) {
				await postSale.addToCartPostSale(null, {zeroTransactions: !postSale.requireTransaction});
			}
		}
	})().catch(e => {
		console.error('postSale_selectForTravelChange', e);
	});
}


provide('solution', travelSolution.value);
provide('source', props.source);


watch(() => props.travSol, (value, old) => {
	if(value && old) console.warn('watch travelsolution test', value, old);
});


onMounted(() => {
	if(props.scrollHere && topToScroll.value) {
		setTimeout(() => {
			topToScroll.value.$el.scrollIntoView({behavior: 'smooth', block: 'start'});
		}, 800)

	}
});
</script>

<style scoped>
img.train-icon {
	height: 0.8rem;
}

.solution-expanded-content{
	border-top: 1px solid #dfdfdf;
	border-bottom: 1px solid #dfdfdf;
}

.card-solution-expanded > .tw-card:first-child{
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
.card-solution-expanded > .tw-card:last-child{
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.price-start-from {
  cursor: pointer;
}

.solution-message {
  background-color: #FFE0B2;
  color: #E65100;
}

:deep(.v-switch .v-selection-control){
	display: flex;
	flex-direction: row-reverse;
	gap: 12px;
}

:deep(.v-switch .v-label){
	font-weight: 500;
}

</style>
